import type { NotebookNote } from '../../../shared/types/notebook'

/** Mutable data bridge for WikiLinkView — updated by TiptapEditor via useEffect */
export const wikiLinkData = {
  allNotes: [] as NotebookNote[],
  onNavigate: undefined as ((noteId: string) => void) | undefined,
}
